import * as types from "../actions/actionTypes";

const initialState = {
  shipment: null,
  shipments: [],
  packageDetails : null
};

const delhivery = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_SHIPMENT:
      return { ...state, shipment: null };
    case types.GET_SHIPMENT:
      return { ...state, shipment: null };
    case types.GET_SHIPMENT_RESPONSES:
      return { ...state, shipment: action?.payload };
    case types.GET_PACKAGE_DETAILS:
      return { ...state, packageDetails: null };
    case types.GET_PACKAGE_DETAILS_RESPONSES:
      return { ...state, packageDetails: action?.payload };
      
    default:
      return state;
  }
};

export default delhivery;
